"use strict";

import module from "./module";

import "./registry.service.spec";

export default module;
